import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "core-selection-drawer-skeleton" } },
    _vm._l(10, function (i) {
      return _c(VSkeletonLoader, {
        key: i,
        staticClass: "core-selection-drawer-skeleton",
        attrs: { type: "list-item-avatar" },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }